import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  brandingAndColors: {},
  loaded: false,
};

const brandingAndColorsSlice = createSlice({
  name: "brandingAndColors",
  initialState,
  reducers: {
    setBrandingAndColors: (state, action) => {
      const { brandingAndColors } = action.payload;
      state.brandingAndColors = brandingAndColors;
      state.loaded = true;
    },
    updateBrandingAndColorsAction: (state, action) => {
      const { brandingAndColors } = action.payload;
      state.brandingAndColors.brand_colors_settings = brandingAndColors;
    },
  },
});

export const { setBrandingAndColors, updateBrandingAndColorsAction } = brandingAndColorsSlice.actions;
export default brandingAndColorsSlice.reducer;
